import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SearchService {
  constructor() {}

  getRouterLink(result: any) {
    return [
      "/app/main",
      {
        outlets: {
          navigation:
            result.navEntryType === "MARKET"
              ? [
                  result.parentIds[
                    result.ParentIds.length - 1
                  ]?.navEntryType?.toLowerCase(),
                  result.parentIds[result.ParentIds.length - 1]?.id,
                ]
              : [result.navEntryType.toLowerCase(), result.id],
          content: ["EVENT", "MARKET", "RACE"].includes(result?.navEntryType)
            ? [
                ["EVENT", "RACE"].includes(result?.navEntryType)
                  ? "event-markets"
                  : "market",
                result.id,
              ]
            : ["home"],
        },
      },
    ];
  }
}
